import mutations, { getDefaultState } from './mutations'
import actions from './actions'

export const conjunto_historico = {
  namespaced: true,
  state: getDefaultState(),
  mutations,
  actions,
}
